import React__default from 'react';
import { Link as Link$1 } from 'react-aria-components';
import './Link.scss';

const Link = (props) => {
    return (React__default.createElement(Link$1, { className: '', ...props, "data-rev-component": 'link' }, props.children));
};

export { Link };
//# sourceMappingURL=Link.js.map
